package com.sweetlime.bingeamigo.presentation.features.settings

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.presentation.features.auth.AuthScreen

object SettingsScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow

        SettingsContent(
            onBack = { navigator.pop() },
            onLogout = { navigator.replaceAll(AuthScreen()) }
        )
    }
}
